var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterAdvanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 12C10.2091 12 11.9999 10.2091 11.9999 8C11.9999 5.79086 10.2091 3.99999 7.99992 3.99999C5.79078 3.99999 3.99992 5.79086 3.99992 8C3.99992 10.2091 5.79078 12 7.99992 12ZM7.99992 10.6667C9.47268 10.6667 10.6666 9.47275 10.6666 8C10.6666 6.52724 9.47268 5.33333 7.99992 5.33333C6.52716 5.33333 5.33325 6.52724 5.33325 8C5.33325 9.47275 6.52716 10.6667 7.99992 10.6667Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66659 1.33333C1.93021 1.33333 1.33325 1.93028 1.33325 2.66666V13.3333C1.33325 14.0697 1.93021 14.6667 2.66659 14.6667H13.3333C14.0696 14.6667 14.6666 14.0697 14.6666 13.3333V2.66666C14.6666 1.93028 14.0696 1.33333 13.3333 1.33333H2.66659ZM13.3333 2.66666L2.66659 2.66666L2.66659 13.3333H13.3333V2.66666Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAdvanced);
export default __webpack_public_path__ + "static/media/IconFilterAdvanced.b88be15e.svg";
export { ForwardRef as ReactComponent };